import {
	Component,
	OnInit,
	ViewChild,
	ElementRef,
	Input,
	Output,
	EventEmitter
} from '@angular/core';
import {
	FormBuilder,
	FormGroup,
	Validators,
	FormControl,
	AbstractControl,
	FormArray
} from '@angular/forms';
import { ValidationService } from 'projects/services/src/app/validation.service';
import { ApiService } from 'projects/services/src/app/API/api.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import * as $ from 'jquery';
declare var toastr: any;
declare var swal: any;
import { ScriptLoaderService } from 'projects/services/src/app/script-loader.service';
import { TpRuleDetails } from 'src/app/interfaces';
import { Helpers } from 'projects/training-calendar/src/app/helpers';
import { TcTpCreationService } from 'projects/services/src/app/API/tc-tp-creation.service';
@Component({
	selector: 'app-tp-registration-rule-form',
	templateUrl: './tp-registration-rule-form.component.html',
	styleUrls: ['./tp-registration-rule-form.component.css']
})
export class TpRegistrationRuleFormComponent implements OnInit {
	@ViewChild('startDate') effectiveDate: ElementRef;
	@Input() isAdmin: any = false;
	@Input() redirectCancelUrl: any = false; // for redircting on Cancel
	@Input() tpRuleDetails: TpRuleDetails;
	@Input() tpRuleCreationForm: FormGroup;
	@Output() onSubmit = new EventEmitter();
	adminFormGroup: FormGroup;
	private approved = false;
	private notApproved = false;
	loggedInUser: any;
	ruleId: string;
	comments: string;
	items: any;
	tpTypeFormGroup: FormGroup;
	rulesForType: any = {
		registration: {
			isPaymentRequired: '',
			amount: null
		},
		unBlocking: {
			isPaymentRequired: '',
			amount: null
		},
		type: ''
	};
	constructor(
		private formBuilder: FormBuilder,
		private apiService: ApiService,
		private router: Router,
		private currentUserService: CurrentUserService,
		private _script: ScriptLoaderService,
		private tcTpCreationService: TcTpCreationService
	) {
		this.loggedInUser = this.currentUserService.decodeToken();
		this.tpRuleDetails = {
			adminRole: 'gegsdedtr',
			rulesForType: [
				{
					registration: {
						isPaymentRequired: '',
						amount: null
					},
					unBlocking: {
						isPaymentRequired: '',
						amount: null
					},
					type: 'Reg'
				},
				{
					registration: {
						isPaymentRequired: '',
						amount: null
					},
					unBlocking: {
						isPaymentRequired: '',
						amount: null
					},
					type: 'Govt'
				}
			],
			blockAttemptAndDuration: {
				noOfBlockAttempts: null,
				durationOfBlock: null,
				noOfDaysToCompleteDesktopAssessment: null
			},
			effectiveDate: '',
			review: []
		};
		const validators = {
			amount: []
		};
		this.tpRuleCreationForm = this.formBuilder.group({
			// govtRegistrationAmount: ['', []],
			// govtRegistrationAmountIsRequired: ['', [Validators.required]],
			// regularRegistrationAmount: ['', []],
			// regularRegistrationAmountIsRequired: ['', [Validators.required]],
			// govtUnblockingAmountIsRequired: ['', [Validators.required]],
			// govtUnblockingAmount: ['', []],
			// regularUnblockingAmountIsRequired: ['', [Validators.required]],
			// regularUnblockingAmount: ['', []],
			noOfBlockAttempts: [
				'',
				[Validators.required,
				Validators.pattern('^[0-9]{1}$'),
				Validators.maxLength(1),
				// Validators.minLength(1),
				// ValidationService.number(6, true),
				Validators.min(0),
				Validators.max(9)]
			],
			durationOfBlock: [
				'',
				[Validators.required,
				Validators.pattern('^[0-9]{1,2}$'),
				Validators.maxLength(2),
				// Validators.minLength(1),
				// ValidationService.number(6, true),
				Validators.min(0),
				Validators.max(12)]
			],
			noOfDaysToCompleteDesktopAssessment: [
				'',
				[Validators.required,
				Validators.pattern('^[0-9]{1,3}$'),
				Validators.maxLength(3),
				// Validators.minLength(1),
				// ValidationService.number(6, true),
				Validators.min(0),
				Validators.max(365)]
			],
			effectiveDate: ['', [Validators.required]],
			status: ['', []],
			rulesForType: this.formBuilder.array([]),
		});
		this.tpTypeFormGroup = this.createRulesForTypeForm();
	}
	createRulesForTypeForm(data?: any) {
		// const educationDetails = this.tpRuleCreationForm.get('tempRuleForType');
		return this.formBuilder.group({
			type: [data ? data.type : '', [Validators.required, Validators.pattern('^[A-Za-z][A-Za-z \s]*$')]],
			registrationAmount: [data ? data.registration ? data.registration.amount : '' : '', []],
			registrationAmountIsRequired: [data ? data.registration ? data.registration.isPaymentRequired : '' : '', [Validators.required]],
			unblockingAmount: [data ? data.unBlocking ? data.unBlocking.amount : '' : '', []],
			unblockingAmountIsRequired: [data ? data.unBlocking ? data.unBlocking.isPaymentRequired : '' : '', [Validators.required]],
		});
	}
	removeTrainingPartnerType(i) {
		this.items = this.tpRuleCreationForm.get('rulesForType') as FormArray;
		this.items.controls.splice(i, 1);
		this.items.value.splice(i, 1);
		this.tpRuleDetails.rulesForType.splice(i, 1);

	}
	cancelTrainingTypeForm() {
		this.tpTypeFormGroup.reset();
	}

	addTrainingPartnerType() {
		this.tpTypeFormGroup = this.createRulesForTypeForm()
		this.rulesForType = {
			registration: {
				isPaymentRequired: '',
				amount: null
			},
			unBlocking: {
				isPaymentRequired: '',
				amount: null
			},
			type: ''
		};
	}
	addToRuleForType() {
		this.items = this.tpRuleCreationForm.get('rulesForType') as FormArray;
		this.items.push(this.tpTypeFormGroup);
		this.tpRuleDetails.rulesForType.push(this.rulesForType);
		console.log(this.items, 'this.items')
	}
	setValidation(really, control: AbstractControl) {
		really = really === 'Yes' ? true : false;
		let validations = [];
		if (really) {
			validations = [
				Validators.required,
				Validators.pattern('^(([0-9]{1,5})|([0-9]{1,5}[.][0-9]{1,2}))'),
				// ValidationService.number(7, true)
				Validators.maxLength(8),
				// Validators.minLength(1),
				Validators.max(99999.99),
				Validators.min(0)
				// ValidationService.number(6, true)
			];
		}
		control.clearValidators();
		control.setValidators(validations);
		control.updateValueAndValidity();
	}

	private setAdminFormGroup() {
		let commentValidation = [];
		let approvalValidation = [];
		if (this.isAdmin) {
			commentValidation = [
				Validators.required,
				Validators.pattern('^[A-Za-z0-9][A-Za-z0-9 \s]*$')
			];
			approvalValidation = [Validators.required];
		}
		this.adminFormGroup = this.formBuilder.group({
			comments: ['', commentValidation],
			approval: ['', approvalValidation]
		});
	}

	ngOnInit() {
		this._script.loadScripts('app-tp-registration-rule', [
			'./assets/demo/default/custom/components/forms/widgets/bootstrap-datepicker.js'
		]);
		this.isAdmin = this.isAdmin === 'true' ? true : false;
		this.setAdminFormGroup();
		if (this.isAdmin) {
			const userName = this.loggedInUser.userName;
			const role = this.loggedInUser.role;
			// const url = `${environment.smartServiceURL}/getPendingTPRuleRequests/${userName}/${role}`;
			// this.apiService.get(url)
			this.tcTpCreationService
				.getTpFormDetails({ userName, role })
				.subscribe(
					(res: any) => {
						if (!res || !res[0]) {
							swal('There is no rule for approval');
							return this.navigateToDashboard();
						}
						console.log(res[0]);
						const rule = res[0];
						this.tpRuleDetails = rule;
						this.tpRuleCreationForm.get('durationOfBlock')
							.setValue(rule.blockAttemptAndDuration.durationOfBlock);
						this.tpRuleCreationForm.get('noOfDaysToCompleteDesktopAssessment')
							.setValue(rule.blockAttemptAndDuration.noOfDaysToCompleteDesktopAssessment);
						this.tpRuleCreationForm.get('noOfBlockAttempts')
							.setValue(rule.blockAttemptAndDuration.noOfBlockAttempts);
						this.tpRuleCreationForm.get('effectiveDate')
							.setValue(rule.effectiveDate);
						const rulesForTypeArray = this.tpRuleCreationForm.get('rulesForType') as FormArray;
						for (let i = 0; i < rule.rulesForType.length; i++) {
							rulesForTypeArray.push(this.createRulesForTypeForm(rule.rulesForType[i]))
						}
						this.ruleId = rule.ruleId;
						const date = this.tpRuleDetails.effectiveDate;
						this.tpRuleDetails.effectiveDate = date
							? Helpers.toCalendarDate(new Date(date))
							: '';
					},
					err => { }
				);
		} else {
			const rulesForTypeArray = this.tpRuleCreationForm.get('rulesForType') as FormArray;
			rulesForTypeArray.push(this.createRulesForTypeForm({ type: 'Reg' }));
			rulesForTypeArray.push(this.createRulesForTypeForm({ type: 'Government' }));
		}
	}
	// ngAfterViewInit() {
	// 	this._script.loadScripts('app-tp-registration-rule', [
	// 		'./assets/demo/default/custom/components/forms/widgets/bootstrap-datepicker.js'
	// 	]);
	// }

	isDisabled() {
		return this.isAdmin ? '' : null;
	}

	approve(isApprove) {
		this.approved = isApprove;
		this.notApproved = !isApprove;
		this.adminFormGroup.get('approval').setValue(isApprove);
	}

	saveRule() {
		if (this.isAdmin) {
			console.log(this.tpRuleDetails.rulesForType)
			this.onSubmit.emit({
				tpRuleDetails: this.tpRuleDetails,
				details: {
					approverUserName: this.loggedInUser.userName,
					approverUserRole: this.loggedInUser.role,
					status: this.approved ? 'Approved' : 'Not Approved',
					comments: this.comments,
					ruleId: this.ruleId,
					rulesForType : this.tpRuleDetails.rulesForType
				}
			});
		} else {
			const tpRuleDetails = Helpers.copyObj(this.tpRuleDetails);
			let date = this.effectiveDate.nativeElement.value;
			date = date.split('/');
			// date = `${date[1]}-${date[0]}-${date[2]}`;
			date = `${date[2]}-${date[1]}-${date[0]}`;
			tpRuleDetails.effectiveDate = new Date(date).toISOString();
			console.log(tpRuleDetails, "tpRuleDetails")
			this.onSubmit.emit({
				tpRuleDetails: tpRuleDetails
			});
		}
	}

	navigateToDashboard() {
		if (this.redirectCancelUrl) {
			this.router.navigate([this.redirectCancelUrl]);
		}
		// if (this.isAdmin) {
		// 	this.router.navigate(['../smartadmin']);
		// } else {
		// 	this.router.navigate(['../smartbusiness']);
		// }
	}
}
